const mobileNavTriggers = ($) => {
    //Mobile nav work
    $(document).on('click', '.hamburger', (e) => {
        const isOpen = $(e.currentTarget).attr('aria-expanded') === 'true';
        //toggle aria-expanded attr
        $(e.currentTarget).attr('aria-expanded', function (i, attr) {
            return attr == 'true'? 'false' : 'true';
        }).toggleClass('is-active');

        if(isOpen) {
            $('html').addClass('main-menu-closing');
            setTimeout(() => {
                $('html').removeClass('main-menu-closing');
            },300)
        }

        $('html').toggleClass('main-menu-open');

    }).on('click', '.faq', (e) => {
        const $el = $(e.currentTarget);
        $el.toggleClass('is-active');
    });
}

export default mobileNavTriggers;